import React from 'react'
import { Cylinder } from '../geometries/Cylinder'
import { Pot } from './Pot'

export const Plant = ({ position, rotation, scale = 1 }) => {
	return (
		<group castShadow position={position} scale={scale} rotation={rotation}>
			<Pot scale={7} />
			<Cylinder size={[1, 1, 20, 50]} position={[0, 20, 0]} color='green' />
			<mesh position={[0, 30, 0]} rotation={[Math.PI / 2, 0, 0]} castShadow>
				<torusKnotGeometry args={[2, 3, 60, 50, 1, 10]} />
				<meshStandardMaterial color={'red'} />
			</mesh>
		</group>
	)
}
